import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Button, Grid } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import YupPassword from "yup-password";
import { FormLabel, TextField, CircularProgress } from "@mui/material";
import { changePassowrd } from "services/awsService/awsService";
import * as Sentry from "@sentry/browser";
YupPassword(yup);

const ChangePassword = ({
  openChangePasswordDialog,
  setOpenChangePasswordDialog,
  setOpenSnackbar,
  setSeverity,
  setAlertMessage,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const schema = yup.object().shape({
    password: yup.string().password().required(),
    newPassword: yup.string().password().required(),
  });
  const defaultValues = {
    password: "",
    newPassword: "",
  };
  const { handleSubmit, reset, control, formState, setValue, getValues } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid, dirtyFields, errors } = formState;

  const changePasswordHandler = (data) => {
    setLoading(true);
    // console.log("Change Password");
    // console.log("data is", data);
    changePassowrd(data.password, data.newPassword)
      .then((resp) => {
        setLoading(false);
        setOpenSnackbar(true);
        setSeverity("success");
        setAlertMessage("Password changed successfully");
        setOpenChangePasswordDialog(false);
      })
      .catch((error) => {
        setLoading(false);
        Sentry.captureException(error);
        setOpenSnackbar(true);
        setSeverity("error");
        setAlertMessage("Error while updating the password: " + error.message);
        console.log(error.message);
      });
  };

  return (
    <Dialog
      open={openChangePasswordDialog}
      onClose={() => {
        setOpenChangePasswordDialog(false);
      }}
    >
      <CloseIcon
        fontSize="medium"
        onClick={() => {
          setOpenChangePasswordDialog(false);
        }}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />

      <DialogTitle>
        <MDTypography variant="h4">Change Password</MDTypography>
        <MDTypography variant="subtitle2" sx={{ fontSize: 13 }}>
          Must contains at least 1 number, 1 special character, 1 uppercase letter, 1 lowercase
          letter
        </MDTypography>
      </DialogTitle>

      <form onSubmit={handleSubmit((data) => changePasswordHandler(data))}>
        <DialogContent>
          <Grid container spacing={2} p={1}>
            <Grid item xs={12} xl={12}>
              <FormLabel sx={{ display: "block", marginBottom: "10px", fontSize: "20px" }}>
                Password
              </FormLabel>
              <Controller
                render={({ field }) => (
                  <TextField
                    sx={{ height: 50 }}
                    size="large"
                    error={!!errors.password}
                    helperText={errors?.password?.message}
                    {...field}
                    inputProps={{
                      autoComplete: "new-title",
                    }}
                    InputProps={{
                      className: "pr-2",
                      type: showPassword ? "text" : "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} size="large">
                            <Icon className="text-20" color="action">
                              {showPassword ? "visibility" : "visibility_off"}
                            </Icon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    fullWidth
                  />
                )}
                name="password"
                control={control}
              />
            </Grid>
            <Grid item xs={12} xl={12}>
              <FormLabel sx={{ display: "block", marginBottom: "10px", fontSize: "20px" }}>
                New Password
              </FormLabel>
              <Controller
                render={({ field }) => (
                  <TextField
                    sx={{ height: 50 }}
                    size="large"
                    error={!!errors.newPassword}
                    helperText={errors?.newPassword?.message}
                    {...field}
                    inputProps={{
                      autoComplete: "new-Password",
                    }}
                    InputProps={{
                      className: "pr-2",
                      type: showNewPassword ? "text" : "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            size="large"
                          >
                            <Icon className="text-20" color="action">
                              {showNewPassword ? "visibility" : "visibility_off"}
                            </Icon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    fullWidth
                  />
                )}
                name="newPassword"
                control={control}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MDBox display="flex" justifyContent="end">
            <Button
              type="submit"
              disabled={loading}
              style={{
                marginTop: "15px",
                color: "white",
                background: "#0AB2D6",
              }}
            >
              {loading ? <CircularProgress color="white" size={20} /> : "Change Password"}
            </Button>
          </MDBox>
          <MDBox display="flex" justifyContent="end">
            <Button
              type="button"
              style={{
                marginTop: "15px",
                color: "white",
                background: "#F6821E",
              }}
              onClick={() => {
                setOpenChangePasswordDialog(false);
              }}
            >
              Close
            </Button>
          </MDBox>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangePassword;
